import { createSelector } from '@ngrx/store';

import { createEntityCollectionStore } from '@recruitee/ngrx';
import type { IsoCurrency } from '@recruitee/payments-types';

const { actions, selectors, reducer, namespace } = createEntityCollectionStore<IsoCurrency>()(
  'Currency',
  {
    idSelector: entity => entity.code,
  },
);

const CurrencySelectors = {
  ...selectors,
  currenciesMap: createSelector(selectors.entities(), currencies =>
    currencies.reduce(
      (acc, currency) => {
        acc[currency.code] = currency.name;
        return acc;
      },
      <Record<string, string>>{},
    ),
  ),
};

export {
  actions as CurrencyActions,
  CurrencySelectors,
  reducer as CurrencyReducer,
  namespace as CurrencyNamespace,
};
